'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var notice = function notice() {
  return import('@/page/notice');
};
var noticeDetail = function noticeDetail() {
  return import('@/page/notice/notice-detail');
};
var noticeList = function noticeList() {
  return import('@/page/notice/notice-list');
};
exports.default = [{
  path: '/notice',
  name: 'notice',
  component: notice,
  children: [{
    path: 'message-detail',
    name: 'message-detail',
    component: noticeDetail
  }, {
    path: 'notice-list',
    name: 'notice-list',
    component: noticeList
  }]
}];